<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none">
        <path
            d="M9.71484 15.4284V0.571289C14.2863 2.857 14.8577 9.14272 14.8577 11.4284H9.71484"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M4 0.571289V15.4284"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M6.85686 0.571289V3.42843C6.85686 3.80363 6.78297 4.17516 6.63938 4.52182C6.49579 4.86846 6.28533 5.18343 6.02003 5.44874C5.75472 5.71404 5.43974 5.9245 5.0931 6.06809C4.74645 6.21168 4.37492 6.28558 3.99972 6.28558C3.24196 6.28558 2.51523 5.98456 1.97941 5.44874C1.4436 4.91292 1.14258 4.18619 1.14258 3.42843V0.571289"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>
